import AchievementsMilestonesSection from '../components/achievements/AchievementsMilestonesSection'
import AchievementsOperationalSection from '../components/achievements/AchievementsOperationalSection'
import AchievementsPageHero from '../components/achievements/AchievementsPageHero'
import AchievementsSuccessFactorsSection from '../components/achievements/AchievementsSuccessFactorsSection'
import AchievementsCommitmentSection from '../components/achievements/AchievementsCommitmentSection'
import AchievementsFutureGoalsSection from '../components/achievements/AchievementsFutureGoalsSection'
import SEO from '../components/common/SEO'

function Achievements() {
  return (
    <>
      <SEO
        title="Achievements"
        description="Torbit Metals focuses on high-volume metal supply execution, client satisfaction, business expansion and strong sourcing capability."
      />
      <AchievementsPageHero />

      <AchievementsMilestonesSection />
      <AchievementsSuccessFactorsSection />
      <AchievementsOperationalSection />
      <AchievementsFutureGoalsSection />
      <AchievementsCommitmentSection />
    </>
  )
}

export default Achievements
